import _typeof from "@babel/runtime/helpers/esm/typeof";
import createWindowFocusMonitor from "./windowFocusMonitor";

function isCaretPosition(option) {
  return ['string', 'function'].indexOf(_typeof(option)) > -1;
}

function getTargetPosition(position, value) {
  if (position === 'head') {
    return 0;
  }

  if (position === 'end') {
    return value.length;
  }

  return position(value);
}

function getAfterMove(position, propAfterMove) {
  if (propAfterMove) {
    return propAfterMove;
  }

  if (position === 'head') {
    return function (el) {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    };
  }

  if (position === 'end') {
    return function (el) {
      el.scrollTop = el.scrollHeight;
      el.scrollLeft = el.scrollWidth;
    };
  }
}

function readonlyManager() {
  var removeReadonlyWhenNeed = null;
  return {
    removeReadonly: function removeReadonly() {
      var _removeReadonlyWhenNe;

      (_removeReadonlyWhenNe = removeReadonlyWhenNeed) === null || _removeReadonlyWhenNe === void 0 ? void 0 : _removeReadonlyWhenNe();
      removeReadonlyWhenNeed = null;
    },
    setReadonly: function setReadonly(el) {
      var hasReadonly = el.hasAttribute('readonly');

      if (!hasReadonly) {
        el.setAttribute('readonly', 'true');

        removeReadonlyWhenNeed = function removeReadonlyWhenNeed() {
          el.removeAttribute('readonly');
        };
      }
    }
  };
}

function createMoveCaretManager(instance) {
  var windowFocusMonitor = createWindowFocusMonitor();

  var _readonlyManager = readonlyManager(),
      removeReadonly = _readonlyManager.removeReadonly,
      setReadonly = _readonlyManager.setReadonly;

  var requestId = null;

  function clearMoveRequest() {
    if (requestId != null) {
      window.cancelAnimationFrame(requestId);
      requestId = null;
    }
  }

  function hasPropFocusCaret() {
    return !!instance.props.focusCaret;
  }

  function shouldMonitorWindowFocus() {
    if (!hasPropFocusCaret()) {
      return false;
    }

    var focusCaret = instance.props.focusCaret;
    var disableReFocus = _typeof(focusCaret) !== 'object' || focusCaret.disableReFocus !== false;
    return disableReFocus;
  }

  function moveCaret(el) {
    var propOption = instance.props.focusCaret;

    if (!propOption) {
      return;
    }

    var option = isCaretPosition(propOption) ? {
      position: propOption
    } : propOption;
    var value = instance.state.value;
    var position = option.position;
    var targetPosition = getTargetPosition(position, value || '');
    var afterMove = getAfterMove(position, option.afterMove); // 如果使用方改变了selectionRange, 则不移动光标位置

    if (el.selectionStart === el.selectionEnd) {
      el.selectionStart = el.selectionEnd = targetPosition;
    } // 即使使用方改变了selectionRange，我们仍然要保留input的滚动行为


    afterMove === null || afterMove === void 0 ? void 0 : afterMove(el);
  }

  return {
    requestMoveCaret: function requestMoveCaret(el) {
      // 使用方没有传focusCaret
      if (!hasPropFocusCaret()) return; // 满足切换窗口refocus的情况

      if (shouldMonitorWindowFocus() && windowFocusMonitor.isRefocused()) {
        return;
      }
      /**
       * 为避免光标闪烁，这里在移动光标位置前先给input设一个readonly
       * 需要注意排除input已经有readonly的情况
       */


      setReadonly(el);
      requestId = window.requestAnimationFrame(function () {
        moveCaret(el);
        removeReadonly();
      });
    },
    handleBlur: function handleBlur() {
      if (shouldMonitorWindowFocus()) {
        windowFocusMonitor.startUp();
      }
    },
    setup: function setup() {
      if (shouldMonitorWindowFocus()) {
        windowFocusMonitor.setup();
      }
    },
    teardown: function teardown() {
      windowFocusMonitor.teardown();
      clearMoveRequest();
      removeReadonly();
    },
    removeReadonly: removeReadonly
  };
}

export default createMoveCaretManager;